"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDestinationClient = void 0;
var MockClient_1 = require("./MockClient");
var Client_1 = require("./Client");
var useMock_1 = __importDefault(require("../util/useMock"));
exports.OrderDestinationClient = {
    get: function (orderDestinationId) { return useMock_1.default() ? MockClient_1.MockOrderDestinationClient.getOneById(orderDestinationId) : Client_1.OrderDestinationClient.getOneById(orderDestinationId); },
    getAllByLocation: function (locationId, authToken) { return useMock_1.default() ? MockClient_1.MockOrderDestinationClient.getAllByLocation(locationId) : Client_1.OrderDestinationClient.getAllByLocation(locationId, authToken); },
    create: function (odDto, authToken) { return useMock_1.default() ? MockClient_1.MockOrderDestinationClient.create(odDto) : Client_1.OrderDestinationClient.create(odDto, authToken); },
    remove: function (orderDestinationId, authToken) { return useMock_1.default() ? new Promise(function (resolve) { return resolve(new Response()); }) : Client_1.OrderDestinationClient.remove(orderDestinationId, authToken); },
    setBaseUrl: function (url) { return Client_1.OrderDestinationClient.setBaseUrl(url); }
};
